import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { analyticsApi } from '../../services/analytics';

interface AnalyticsState {
  selectedDateRange: {
    startDate: string | null;
    endDate: string | null;
  };
  selectedReportType: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  selectedDateRange: {
    startDate: null,
    endDate: null,
  },
  selectedReportType: null,
  isLoading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setDateRange: (state, action: PayloadAction<{ startDate: string | null; endDate: string | null }>) => {
      state.selectedDateRange = action.payload;
    },
    setReportType: (state, action: PayloadAction<string | null>) => {
      state.selectedReportType = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearAnalytics: (state) => {
      state.selectedDateRange = { startDate: null, endDate: null };
      state.selectedReportType = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        analyticsApi.endpoints.getAnalyticsReport.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        analyticsApi.endpoints.getAnalyticsReport.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        analyticsApi.endpoints.getAnalyticsReport.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження аналітики';
        }
      );
  },
});

export const {
  setDateRange,
  setReportType,
  setLoading,
  setError,
  clearAnalytics,
} = analyticsSlice.actions;

export default analyticsSlice.reducer; 